import { memo } from "react";

import type {
	GoogleFreeBookingLinksSettingsHotelTypeSelectionModalQuery,
	HotelApplicationDataQueryQuery,
} from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog/dialog";

import { HotelTypeFieldset } from "./hotel-type-fieldset";
import { useHotelTypeSubmit } from "./use-hotel-type-submit";
import { useModalState } from "./use-modal-state";
import { useGoogleFreeBookingLinksSettingsHotelTypeForm } from "../../hooks";

type Props = {
	googleFreeBookingLinksSettingsQueryData: GoogleFreeBookingLinksSettingsHotelTypeSelectionModalQuery;
	hotelApplicationData: HotelApplicationDataQueryQuery;
};

export const ModalGoogleFreeBookingLinksIslandSettings = memo(
	({ googleFreeBookingLinksSettingsQueryData: { googleFreeBookingLinksSettings }, hotelApplicationData }: Props) => {
		const { form, isNew } = useGoogleFreeBookingLinksSettingsHotelTypeForm({
			googleFreeBookingLinksSettings,
		});

		const { open, closeModal } = useModalState({ isNew, hotelApplicationData });
		const { handleSubmit } = useHotelTypeSubmit({ form, callbackFunc: closeModal });

		const {
			register,
			watch,
			formState: { isValid },
		} = form;
		const selectedHotelType = watch("hotelType");

		return (
			<Dialog modal open={open}>
				<DialogContent className="max-w-2xl" hideCloseButton>
					<DialogHeader className="space-y-4">
						<DialogTitle className="text-xl font-semibold">施設タイプの調査にご協力ください</DialogTitle>

						<div>
							<p className="mb-4">
								より良いサービスを提供するため、ご利用いただいている施設の属性を調査させていただいております。
							</p>
							<p>下記からご自身の施設に最も近いタイプを選択してください。</p>
							<p className="mb-4">
								※いずれのタイプにも当てはまらない場合は「屋外宿泊施設」を選択してください。
							</p>
							<p>お手数をおかけいたしますが、ご協力のほどよろしくお願いいたします。</p>
						</div>
					</DialogHeader>

					<form onSubmit={handleSubmit} className="space-y-6">
						<HotelTypeFieldset
							register={register}
							selectedHotelType={selectedHotelType}
							fieldName="hotelType"
						/>

						<div className="flex justify-end pt-4">
							<Button
								type="submit"
								variant="default"
								size="lg"
								disabled={!isValid}
								onClick={handleSubmit}
							>
								送信する
							</Button>
						</div>
					</form>
				</DialogContent>
			</Dialog>
		);
	},
);
